import config from '@app/config'

import {
  CULTURE_TO_DOMAINS,
  DEFAULT_CULTURE,
  type PortalEnvironment,
} from './constants'

const normalizeDomain = (value: string): string =>
  value.replace(/^https?:\/\//u, '').toLowerCase()

const normalizeCulture = (value: string): string =>
  value.trim().replace(/_/g, '-').toLowerCase()

const getRegionalCulture = (): string | undefined => {
  const language = config.regionalSettings?.language?.trim().toLowerCase()
  const countryISO = config.regionalSettings?.countryISO?.trim().toUpperCase()

  if (!language || !countryISO) {
    return undefined
  }

  return `${language}-${countryISO}`
}

export const getCultureByDomain = (): string | undefined => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return undefined
  }

  const env = (config.environment ?? 'development') as PortalEnvironment
  const environmentDomains =
    CULTURE_TO_DOMAINS[env] ?? CULTURE_TO_DOMAINS.development
  const hostname = window.location.hostname.toLowerCase()
  const domainCultures = Object.entries(environmentDomains)
    .filter(([, domain]) => normalizeDomain(domain) === hostname)
    .map(([culture]) => culture)

  if (domainCultures.length === 0) {
    return DEFAULT_CULTURE
  }

  if (domainCultures.length === 1) {
    return domainCultures[0]
  }

  const regionalCulture = getRegionalCulture()
  if (regionalCulture) {
    const normalizedRegionalCulture = normalizeCulture(regionalCulture)
    const exactCulture = domainCultures.find(
      (culture) => normalizeCulture(culture) === normalizedRegionalCulture
    )
    if (exactCulture) {
      return exactCulture
    }
  }

  return DEFAULT_CULTURE
}